import { z } from 'zod';

/**
 * Document template create/update form schema.
 * Used for validation in DocumentTemplateEditModal.
 */
export const documentTemplateFormSchema = z.object({
  document_type_id: z
    .number()
    .optional()
    .refine(val => val !== undefined && val >= 1, {
      message: '種類は必須です。',
    }),
  is_default: z.boolean().optional(),
  title: z
    .union([z.string(), z.undefined()])
    .transform(s => (typeof s === 'string' ? s : '').trim())
    .refine(s => s.length >= 1, { message: '表題は必須です。' })
    .refine(s => s.length <= 255, { message: '表題は255文字以内で入力してください。' }),
  content_prefix: z
    .string()
    .max(255, '始めは255文字以内で入力してください。')
    .optional()
    .or(z.literal(''))
    .transform(v => (v === undefined ? '' : v)),
  content: z
    .string()
    .max(1000, '本文は1000文字以内で入力してください。')
    .optional()
    .or(z.literal(''))
    .transform(v => (v === undefined ? '' : v)),
  content_suffix: z
    .string()
    .max(255, '結びは255文字以内で入力してください。')
    .optional()
    .or(z.literal(''))
    .transform(v => (v === undefined ? '' : v)),
  suffix_type_id: z
    .number()
    .optional()
    .refine(val => val !== undefined && val >= 1, {
      message: '敬称は必須です。',
    }),
});

export type DocumentTemplateFormData = z.infer<typeof documentTemplateFormSchema>;
